import React from 'react'

import { Text } from './Text'

/** Mapping from legacy icon names to Font Awesome classes */
const FA_ICON_MAP = {
  home: 'fa-solid fa-house',
  acquisition: 'fa-solid fa-file-import',
  agencies: 'fa-solid fa-building',
  family: 'fa-solid fa-users',
  'controls-2': 'fa-solid fa-sliders',
  monitor: 'fa-solid fa-desktop',
  menu: 'fa-solid fa-bars',
  close: 'fa-solid fa-xmark',
  check: 'fa-solid fa-check',
  edit: 'fa-solid fa-pen-to-square',
  bin: 'fa-solid fa-trash',
  add: 'fa-solid fa-plus',
  'cloud-up': 'fa-solid fa-cloud-arrow-up',
  sync: 'fa-solid fa-arrows-rotate',
  lens: 'fa-solid fa-magnifying-glass',
  info: 'fa-solid fa-circle-info',
  plus: 'fa-solid fa-plus',
  folder: 'fa-solid fa-folder',
  see: 'fa-solid fa-eye',
  hide: 'fa-solid fa-eye-slash',
  'primeicon pi-power-off': 'fa-solid fa-power-off',
  // Additional mappings for icons in IconList (not actively used but kept for completeness)
  account: 'fa-solid fa-user',
  'add-person': 'fa-solid fa-user-plus',
  alarm: 'fa-solid fa-bell',
  'archive-2': 'fa-solid fa-box-archive',
  archive: 'fa-solid fa-box-archive',
  assign: 'fa-solid fa-user-check',
  attached: 'fa-solid fa-paperclip',
  'attention-2': 'fa-solid fa-triangle-exclamation',
  'attention-circle-2': 'fa-solid fa-circle-exclamation',
  'attention-circle': 'fa-solid fa-circle-exclamation',
  attention: 'fa-solid fa-triangle-exclamation',
  back: 'fa-solid fa-arrow-left',
  beach: 'fa-solid fa-umbrella-beach',
  bike: 'fa-solid fa-bicycle',
  binoculars: 'fa-solid fa-binoculars',
  blocknote: 'fa-solid fa-note-sticky',
  'browser-search': 'fa-solid fa-magnifying-glass',
  browser: 'fa-solid fa-globe',
  business: 'fa-solid fa-briefcase',
  'calendar-happy': 'fa-solid fa-calendar-check',
  'calendar-sad': 'fa-solid fa-calendar-xmark',
  calendar: 'fa-solid fa-calendar',
  camp: 'fa-solid fa-campground',
  camper: 'fa-solid fa-caravan',
  car: 'fa-solid fa-car',
  cart: 'fa-solid fa-cart-shopping',
  change: 'fa-solid fa-right-left',
  'chat-history': 'fa-solid fa-clock-rotate-left',
  chat: 'fa-solid fa-comment',
  chat2: 'fa-solid fa-comments',
  'check-round': 'fa-solid fa-circle-check',
  climbing: 'fa-solid fa-person-hiking',
  clock: 'fa-solid fa-clock',
  'cloud-down': 'fa-solid fa-cloud-arrow-down',
  cocktail: 'fa-solid fa-martini-glass',
  coffee: 'fa-solid fa-mug-hot',
  connection: 'fa-solid fa-plug',
  controls: 'fa-solid fa-sliders',
  copy: 'fa-solid fa-copy',
  cruise: 'fa-solid fa-ship',
  culture: 'fa-solid fa-landmark',
  'database-2': 'fa-solid fa-database',
  'database-time': 'fa-solid fa-database',
  database: 'fa-solid fa-database',
  'details-2': 'fa-solid fa-ellipsis',
  details: 'fa-solid fa-ellipsis-vertical',
  diagram: 'fa-solid fa-diagram-project',
  'doc-2': 'fa-solid fa-file-lines',
  documents: 'fa-solid fa-folder-open',
  dog: 'fa-solid fa-dog',
  dollar: 'fa-solid fa-dollar-sign',
  'down-2': 'fa-solid fa-angles-down',
  'down-round': 'fa-solid fa-circle-chevron-down',
  down: 'fa-solid fa-chevron-down',
  download: 'fa-solid fa-download',
  drag: 'fa-solid fa-grip-vertical',
  'edit-2': 'fa-solid fa-pen',
  elements: 'fa-solid fa-cubes',
  'eliminate-round': 'fa-solid fa-circle-xmark',
  emoticons: 'fa-solid fa-face-smile',
  estimate: 'fa-solid fa-calculator',
  experiments: 'fa-solid fa-flask',
  'expired-2': 'fa-solid fa-calendar-xmark',
  expired: 'fa-solid fa-hourglass-end',
  expiring: 'fa-solid fa-hourglass-half',
  extreme: 'fa-solid fa-bolt',
  facebook: 'fa-brands fa-facebook',
  fax: 'fa-solid fa-fax',
  'folder-2': 'fa-solid fa-folder-open',
  go: 'fa-solid fa-arrow-right',
  gourmet: 'fa-solid fa-utensils',
  happy: 'fa-solid fa-face-smile',
  headphones: 'fa-solid fa-headphones',
  history: 'fa-solid fa-clock-rotate-left',
  hotel: 'fa-solid fa-hotel',
  image: 'fa-solid fa-image',
  import: 'fa-solid fa-file-import',
  'info-2': 'fa-solid fa-info',
  instagram: 'fa-brands fa-instagram',
  'left-2': 'fa-solid fa-angles-left',
  'left-round': 'fa-solid fa-circle-chevron-left',
  left: 'fa-solid fa-chevron-left',
  legal: 'fa-solid fa-scale-balanced',
  link: 'fa-solid fa-link',
  linkedin: 'fa-brands fa-linkedin',
  love: 'fa-solid fa-heart',
  'mail-open': 'fa-solid fa-envelope-open',
  mail: 'fa-solid fa-envelope',
  minus: 'fa-solid fa-minus',
  money: 'fa-solid fa-money-bill',
  'more-love': 'fa-solid fa-heart-circle-plus',
  'more-star': 'fa-solid fa-star-half-stroke',
  motorbike: 'fa-solid fa-motorcycle',
  mountain: 'fa-solid fa-mountain',
  'new-box-2': 'fa-solid fa-box',
  'new-box': 'fa-solid fa-box',
  notes: 'fa-solid fa-sticky-note',
  notification: 'fa-solid fa-bell',
  'paperwork-2': 'fa-solid fa-file-contract',
  paperwork: 'fa-solid fa-file-alt',
  pc: 'fa-solid fa-computer',
  'phone-chat': 'fa-solid fa-phone-volume',
  phone: 'fa-solid fa-phone',
  photo: 'fa-solid fa-camera',
  pinterest: 'fa-brands fa-pinterest',
  plane: 'fa-solid fa-plane',
  play: 'fa-solid fa-play',
  pointer: 'fa-solid fa-hand-pointer',
  print: 'fa-solid fa-print',
  proceed: 'fa-solid fa-forward',
  'questions-2': 'fa-solid fa-circle-question',
  questions: 'fa-solid fa-question',
  'quote-2': 'fa-solid fa-quote-right',
  quote: 'fa-solid fa-quote-left',
  resize: 'fa-solid fa-up-right-and-down-left-from-center',
  'right-2': 'fa-solid fa-angles-right',
  'right-round': 'fa-solid fa-circle-chevron-right',
  right: 'fa-solid fa-chevron-right',
  sad: 'fa-solid fa-face-frown',
  send: 'fa-solid fa-paper-plane',
  settings: 'fa-solid fa-gear',
  share: 'fa-solid fa-share-nodes',
  'sheet-2': 'fa-solid fa-table',
  'sheet-new': 'fa-solid fa-file-circle-plus',
  sheet: 'fa-solid fa-sheet-plastic',
  shield: 'fa-solid fa-shield',
  silence: 'fa-solid fa-bell-slash',
  'sincronize-pc': 'fa-solid fa-rotate',
  'sincronize-phone': 'fa-solid fa-rotate',
  'sincronize-siap': 'fa-solid fa-rotate',
  site: 'fa-solid fa-globe',
  size: 'fa-solid fa-maximize',
  skype: 'fa-brands fa-skype',
  star: 'fa-solid fa-star',
  't-shirt': 'fa-solid fa-shirt',
  tablet: 'fa-solid fa-tablet-screen-button',
  teatre: 'fa-solid fa-masks-theater',
  telephone: 'fa-solid fa-phone-flip',
  tent: 'fa-solid fa-tent',
  'thumb-down': 'fa-solid fa-thumbs-down',
  'thumb-up': 'fa-solid fa-thumbs-up',
  ticket: 'fa-solid fa-ticket',
  tool: 'fa-solid fa-wrench',
  train: 'fa-solid fa-train',
  'travel-2': 'fa-solid fa-suitcase-rolling',
  travel: 'fa-solid fa-suitcase',
  tree: 'fa-solid fa-tree',
  twitter: 'fa-brands fa-x-twitter',
  'up-2': 'fa-solid fa-angles-up',
  'up-round': 'fa-solid fa-circle-chevron-up',
  up: 'fa-solid fa-chevron-up',
  volume: 'fa-solid fa-volume-high',
  world: 'fa-solid fa-earth-americas',
  youtube: 'fa-brands fa-youtube',
  'zoom-in': 'fa-solid fa-magnifying-glass-plus',
  'zoom-out': 'fa-solid fa-magnifying-glass-minus',
  accident: 'fa-solid fa-car-burst',
  'xls-2': 'fa-solid fa-file-excel',
  pdf: 'fa-solid fa-file-pdf',
  'pdf-2': 'fa-solid fa-file-pdf'
}

/** Resolve an icon name to a Font Awesome class string */
const resolveFaClass = (name) => {
  if (!name) return FA_ICON_MAP.agencies
  return FA_ICON_MAP[name] || `fa-solid fa-${name}`
}

const renderBadge = (badge, badgeSize) => (
  <div
    style={{
      borderRadius: '50%',
      width: badgeSize || 16,
      height: badgeSize || 16,
      backgroundColor: 'rgb(145, 0, 0)',
      position: 'absolute',
      right: -8,
      bottom: -4
    }}
  >
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Text
        size={badgeSize - 4 || 12}
        color='white'
        style={{ fontFamily: 'Lato', padding: 4, paddingTop: 5 }}
        center
        value={badge}
      />
    </div>
  </div>
)

const renderWithImage = ({ image, size, badge, style, onClick, imageStyle, text }) => {
  const badgeNumber = badge === 0 ? null : badge
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }} onClick={onClick}>
      <div
        style={{
          padding: 5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 100,
          height: 100,
          backgroundColor: 'white',
          borderRadius: '50px',
          flexDirection: 'column',
          ...style
        }}
      >
        <img
          src={image}
          alt=''
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            margin: 'auto',
            padding: 10,
            ...imageStyle
          }}
        />
        {badgeNumber && renderBadge(badgeNumber)}
      </div>
      {text && <Text style={{ textAlign: 'center', marginTop: 10 }} bold value={text} />}
    </div>
  )
}

const renderIcon = ({
  name,
  size,
  badge,
  bold,
  style,
  onClick,
  color,
  iconStyle,
  text,
  textStyle,
  badgeSize,
  posed,
  onMouseOver,
  onMouseIn,
  onMouseOut
}) => {
  const iconSize = size || 36
  const className = resolveFaClass(name)
  const badgeNumber = badge === 0 ? null : badge

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: iconSize,
          height: iconSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style
        }}
        onClick={onClick}
        onMouseOver={onMouseOver}
        onMouseEnter={onMouseIn}
        onMouseLeave={onMouseOut}
      >
        <i
          className={className}
          style={{
            fontSize: iconSize,
            textShadow: bold
              ? '0.6px 0.6px 0 currentColor, -0.6px 0 0 currentColor'
              : '',
            ...(color === 'inherit' ? {} : { color: !posed ? color || '#32324e' : '' }),
            ...iconStyle
          }}
        >
          {badgeNumber && renderBadge(badgeNumber, badgeSize)}
        </i>
      </div>
      {text && (
        <Text
          style={{
            ...textStyle,
            marginTop: 10,
            textAlign: 'center'
          }}
          bold
          value={text}
        />
      )}
    </>
  )
}

export const Icon = (props) => {
  if (props.image) return renderWithImage(props)
  return renderIcon(props)
}

export const IconList = () => Object.keys(FA_ICON_MAP).filter(k => k !== 'primeicon pi-power-off')
